














































import Vue from 'vue';
import Component from 'vue-class-component';

/** Composant pour la promotion de Mon espace santé */
@Component
export default class PromoEspaceSante extends Vue {}
